import { gql } from 'apollo-angular';

const SET_INCLUSION_FLAG = gql`
  mutation setInclusionFlag(
    $rfpId: Long!
    $memberId: Long
    $offerId: Long!
    $included: String!
  ) {
    setInclusionFlag(
      setInclusionFlagRequest: {
        rfpId: $rfpId
        memberId: $memberId
        offerId: $offerId
        included: $included
      }
    ) {
      updated
    }
  }
`;

export default SET_INCLUSION_FLAG;
